import { render, staticRenderFns } from "./LayoutTabContent.vue?vue&type=template&id=46b6f816&scoped=true&"
import script from "./LayoutTabContent.vue?vue&type=script&lang=ts&"
export * from "./LayoutTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6f816",
  null
  
)

export default component.exports